// extracted by mini-css-extract-plugin
module.exports = {"root":"TeaserVideo_root_3enNh","cover":"TeaserVideo_cover_3r0Po","overlay":"TeaserVideo_overlay_3_k2M","play":"TeaserVideo_play_2PYK8"};